import type React from "react"
import { useTranslation } from "react-i18next"
import "../../assets/style/Skills.css"
import { FaHtml5, FaReact, FaPython } from "react-icons/fa"
import { SiTailwindcss, SiNextdotjs, SiSymfony, SiPowerbi, SiMicrosoftexcel, SiPostgresql } from "react-icons/si"
import type { IconType } from "react-icons"

interface SkillProps {
  name: string
  icon: IconType
  color: string
}

const skills: SkillProps[] = [
  { name: "HTML", icon: FaHtml5, color: "#E34F26" },
  { name: "Tailwind", icon: SiTailwindcss, color: "#06B6D4" },
  { name: "React.js", icon: FaReact, color: "#61DAFB" },
  { name: "Next.js", icon: SiNextdotjs, color: "#e2e8f0" },
  { name: "React Native", icon: FaReact, color: "#61DAFB" },
  { name: "Symfony", icon: SiSymfony, color: "#c7d2fe" },
  { name: "Python", icon: FaPython, color: "#3776AB" },
  { name: "PowerBI", icon: SiPowerbi, color: "#F2C811" },
  { name: "Excel", icon: SiMicrosoftexcel, color: "#217346" },
  { name: "PostgreSQL", icon: SiPostgresql, color: "#336791" },
]

const descriptionKeys: Record<string, string> = {
  "HTML": "skillsDescription.HTML",
  "Tailwind": "skillsDescription.Tailwind",
  "React.js": "skillsDescription.React",
  "Next.js": "skillsDescription.Next",
  "React Native": "skillsDescription.ReactNative",
  "Symfony": "skillsDescription.Symfony",
  "Python": "skillsDescription.Python",
  "PowerBI": "skillsDescription.PowerBI",
  "Excel": "skillsDescription.Excel",
  "PostgreSQL": "skillsDescription.PostgreSQL",
}

const SkillsSwiper: React.FC = () => {
  const { t } = useTranslation(undefined, { useSuspense: false })

  return (
    <div className="skills-container">
      <div className="skills__frontend">
        {skills.map((skill, index) => (
          <div
            className="card"
            key={index}
            style={{ '--skill-color': skill.color } as React.CSSProperties}
          >
            <div className="scenes">

              {/* Front */}
              <div className="scene-front">
                <skill.icon size={40} color={skill.color} />
                <h3 className="skill-name">{skill.name}</h3>
              </div>

              {/* Back */}
              <div className="scene-back">
                <skill.icon size={22} color={skill.color} />
                <h3 className="skill-name">{skill.name}</h3>
                <p className="skill-description">
                  {t(descriptionKeys[skill.name] ?? "skillsDescription.HTML")}
                </p>
              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SkillsSwiper
